import React, { useState } from 'react';
import {
	EditAliasActions,
	Line,
	MetadataSummaryLine,
	Select,
	SelectWrapper,
	SummaryLabel,
	SummaryValue,
	ValueWrapper,
} from './EditAlias.styles';
import { MetadataSummary } from 'Settings/ExportMetadataSection/styles';
import {
	ApButtonMain,
	ApButtonSecondary,
	ApInput,
	ApLoaderDefault,
} from '@alixpartners/ui-components';
import { getIdealDenomination } from 'utils/number';
import { uniqBy } from 'lodash';
import { UNITS } from 'Settings';
import { saveAliasMetadata } from 'utils/apiRequests';
import { useToastMessageContext } from 'contexts/ToastMessageContext/ToastMessageProvider';
import { NotificationTypes } from 'components/Toast/constants';

const NOT_SET = 'Not set';

const getOptions = dataOptions => {
	return uniqBy(
		[
			{
				label: NOT_SET,
				value: NOT_SET,
			},
			...(dataOptions || []).map(opt => ({
				label: opt.value,
				value: opt.key,
			})),
		],
		'value'
	);
};

const getUnitOptions = () => [
	{
		label: 'None',
		value: 1,
		worth: 1,
	},
	...UNITS.map(unit => ({
		...unit,
		label: unit.value,
	})),
];

const EditAlias = props => {
	const {
		row,
		industryOptions,
		onClose,
		onUpdateAlias,
		setAliasToEdit,
		refetchAliasData,
	} = props;
	const { showToast } = useToastMessageContext();
	const { id, aliasName, industryKey, revenue } = row;
	const allUnitOptions = getUnitOptions();
	const revenueIdealDenomination = revenue ? getIdealDenomination(revenue) : 1;
	const unitOption = allUnitOptions.find(
		option => option.worth === revenueIdealDenomination
	);
	const [isSaving, setIsSaving] = useState(false);
	const [revenueUnit, setRevenueUnit] = useState(unitOption.value);
	const [revenueValue, setRevenueValue] = useState(
		revenue ? revenue / revenueIdealDenomination : ''
	);

	const saveSettings = () => {
		let bodyParam = {
			aliasName: aliasName,
			industry: industryKey,
			revenue: revenue,
		};

		setIsSaving(true);
		saveAliasMetadata(bodyParam).then(response => {
			if (response.succeeded) {
				setIsSaving(false);
				onClose(false);
				refetchAliasData();
				showToast(
					'Alias updated successfully.',
					NotificationTypes.success,
					4000
				);
			} else {
				setIsSaving(false);
				showToast(
					'Failed to update the Alias.',
					NotificationTypes.danger,
					4000
				);
			}
		});
	};
	return (
		<>
			<h3>
				Update Settings - <b>{aliasName}</b>
			</h3>
			<Line />
			{isSaving ? (
				<ApLoaderDefault
					loaderText={() => (
						<p style={{ textAlign: 'center' }}>Saving settings, please wait!</p>
					)}
				/>
			) : (
				<>
					<MetadataSummary>
						<MetadataSummaryLine>
							<SummaryLabel>Industry:</SummaryLabel>
							<SummaryValue>
								<Select
									name={`${id}_${aliasName}_industry`}
									onChange={v => {
										onUpdateAlias('industryKey', v);
									}}
									options={getOptions(industryOptions)}
									value={industryKey}
								/>
							</SummaryValue>
						</MetadataSummaryLine>
						<MetadataSummaryLine>
							<SummaryLabel>Revenue:</SummaryLabel>
							<SummaryValue>
								<ValueWrapper>
									<ApInput
										type="number"
										name="revenue"
										onChange={v => {
											if (isNaN(v) || v === '') {
												setRevenueValue('');
											} else {
												setRevenueValue(parseFloat(v));
											}
											const foundOption = allUnitOptions.find(
												option => option.value === revenueUnit
											);
											onUpdateAlias(
												'revenue',
												parseFloat(v) * parseInt(foundOption.worth)
											);
										}}
										value={revenueValue}
										shouldStopPropagation
									/>
								</ValueWrapper>
								<SelectWrapper>
									<Select
										name={`${id}_${aliasName}_revenue`}
										small
										options={allUnitOptions}
										value={revenueUnit}
										onChange={v => {
											const foundOption = allUnitOptions.find(
												option => option.value === v
											);
											setRevenueUnit(foundOption.value);
											onUpdateAlias(
												'revenue',
												parseFloat(revenueValue) * parseInt(foundOption.worth)
											);
										}}
									/>
								</SelectWrapper>
							</SummaryValue>
						</MetadataSummaryLine>
					</MetadataSummary>
					<EditAliasActions>
						<div style={{ margin: '0 5px 0 0' }}>
							<ApButtonMain onClick={saveSettings}>Save</ApButtonMain>
						</div>
						<div>
							<ApButtonSecondary
								onClick={() => {
									onClose(false);
									setAliasToEdit({});
								}}
							>
								Close
							</ApButtonSecondary>
						</div>
					</EditAliasActions>
				</>
			)}
		</>
	);
};

export default EditAlias;
